export const VARIATION_WEIGHT = "WEIGHT";
export const VARIATION_PIECES = "PIECES";
